import { Header } from "arv-extends";

const { wrapper, getFinalComponent } = Header.MobileHeader.MobileTopBar;

class ProjectComponent extends wrapper {
  render() {
    return null;
  }
}

Header.MobileHeader.MobileTopBar.component = getFinalComponent(ProjectComponent);
